import { Controller } from "@hotwired/stimulus";
import { hasActiveRegistration } from "../helpers/active_registration";

export default class AuthSyncController extends Controller {
  static targets = ["input"];
  static values = { session: String };

  connect() {
    this.active = true;
    this.handlePageShow = event => { if (event.persisted) this.checkSession(); };
    globalThis.addEventListener("pageshow", this.handlePageShow);
    this.checkSession();
    this.tabId = sessionStorage.getItem("auth_sync_tab_id");

    if (!this.tabId) {
      this.tabId = crypto.randomUUID();
      sessionStorage.setItem("auth_sync_tab_id", this.tabId);
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = this.tabId;
    }
  }

  disconnect() {
    this.active = false;
    globalThis.removeEventListener("pageshow", this.handlePageShow);
  }

  async checkSession() {
    if (!this.hasSessionValue || this.checkingSession || hasActiveRegistration()) return;
    this.checkingSession = true;
    try {
      const response = await fetch('/sessions/status', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok || response.redirected) return;
      const state = await response.json();
      if (this.active && !hasActiveRegistration() && state.session_state !== this.sessionValue) globalThis.location.reload();
    } catch { /* A temporary connection failure must not interrupt navigation. */ }
    finally { this.checkingSession = false; }
  }

  inputTargetConnected(element) {
    element.value = this.tabId;
  }

  getTabId() {
    return this.tabId;
  }
}
